import { render } from "./ComputerId.vue?vue&type=template&id=fec6010e"
import script from "./ComputerId.vue?vue&type=script&lang=js"
export * from "./ComputerId.vue?vue&type=script&lang=js"

import "./ComputerId.vue?vue&type=style&index=0&id=fec6010e&lang=css"

import exportComponent from "/var/www/html/nutrition/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__